import type { ChangeEvent, JSX } from "react";
import { cn } from "@openreel/ui";
import { SOURCE_TEXT_ICON } from "./options";
import { FIELD_FOCUS, FIELD_INPUT, FIELD_MOTION, PILL_BASE } from "./surface";

export interface SourceTextInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  label: string;
}

/**
 * The "Other" source answer: the chip row is replaced by a single pill-shaped
 * free-text field in the same visual language as the chips.
 */
export function SourceTextInput({
  value,
  placeholder,
  onChange,
  label,
}: SourceTextInputProps): JSX.Element {
  const Icon = SOURCE_TEXT_ICON;

  return (
    <label
      className={cn(
        PILL_BASE,
        FIELD_MOTION,
        FIELD_FOCUS,
        "w-full max-w-sm cursor-text bg-white/[0.06] text-[#a8a8a8]",
      )}
    >
      <Icon size={16} strokeWidth={1.5} aria-hidden />
      <span className="sr-only">{label}</span>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        autoFocus
        autoComplete="off"
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.value)
        }
        className={FIELD_INPUT}
      />
    </label>
  );
}
